import React, { useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha';
import { Link, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { BounceLoader } from 'react-spinners';
import { loaderEnd, loaderStart } from '../../components/loader';
import { LoginData } from '../../information/actions';
import { getDataAfterLogin } from '../../store/auth/actions';

import swal from 'sweetalert';
import './login.css'
// .register-container lives here and is shared with the Register screen.
// Without this import the layout depends on Register.jsx having been bundled.
import '../Register/register.css'

const Login = (props) => {
  const navigate = useNavigate()
  const [reCaptcha, setReCaptcha] = useState(false)
  let [val, setVal] = useState({
    aadhar: '',
    dob: '',
  })

  // const onLogin = () => {
  //   setLoading(!loading)

  //   setTimeout(() => {
  //     navigate('/application')
  //   }, 2000);
  // }

  // const onLogin = () => {
  //   loaderStart()
  //   navigate('/application')
  //   loaderEnd()

  // }
  const changeHandle = (e) => {
    setVal({ ...val, [e.target.name]: e.target.value })
  }


  const onLogin = async (e) => {
    e.preventDefault()
    loaderStart()
    if (reCaptcha) {
      let sendval = {
        aadhar: val.aadhar,
        dob: val.dob,
      }
      let res = await LoginData(sendval)
      if (res.code === 1) {
        loaderStart()
        localStorage.setItem("BIPARD-registration", JSON.stringify({
          data: res.result,
          token: res.token
        }))
        props.getDataAfterLogin({
          data: res.result,
          token: res.token
        })
        swal(res.msg, "", "success")
        navigate('/application')
      }
      else {
        swal(res.msg, "", "error")
      }
    }
    else if (val.aadhar === '') {
      swal("Please Enter Aadhar Number", "", "error")
    }
    else if (val.dob === '') {
      swal("Please Enter DOB", "", "error")
    }
    else {
      swal("Please Verify captcha to Continue", "", "error")
    }
    loaderEnd()
  }

  const captchaClick = (e) => {
    setReCaptcha(e);
  }
  console.log(props.auth);
  return (
    <>
      {/* {
        loading ? <BounceLoader
          color={color}
          loading={loading}
          cssOverride={override}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        /> :  */}
            <section className='login'>
                <div className='register-container'>
                    <div className='instruction ui_auth_aside'>
                        <h3>GENERAL INSTRUCTIONS / सामान्य निर्देश</h3>
                        <hr />
                        {/* Was a list of <h4> headings used as body copy — 18px,
                            no line-height, which read as shouting. Plain list
                            items with proper leading. */}
                        <ul className='ui_auth_list'>
                            <li>Incomplete application form shall be rejected.</li>
                            <li>अपूर्ण आवेदन पत्र स्वीकार्य नहीं होंगे।</li>
                            <li>Please read all the instructions carefully before filling up the form.</li>
                            <li>कृप्या प्रपत्र भरने से पहले सभी निर्देशों को ध्यानपूर्वक पढ़ें।</li>
                            <li>Applicant’s signature is mandatory on the application form.</li>
                            <li>आवेदन पत्र पर प्रार्थी का हस्ताक्षर अनिवार्य है।</li>
                            <li>Please make sure the details mentioned in the application form are the same as the details filled in the examination hall.</li>
                            <li>कृपया सुनिश्चित करें कि आवेदन पत्र में उल्लिखित विवरण परीक्षा हॉल में भरे जाने वाले विवरण के समान होना चाहिए।</li>
                        </ul>
                    </div>

                    <div className='form'>
                        <div className='ui_panel'>
                            <div className='ui_panel_head'>
                                <h2 className='ui_panel_title'>Candidate Login</h2>
                            </div>

                            <form className='ui_panel_body' onSubmit={(e) => e.preventDefault()}>
                                <p className='ui_note_required'>Fields marked with * are mandatory</p>

                                <div className='ui_field'>
                                    <label className='ui_label' htmlFor='aadhar'>
                                        <span className='ui_required'>*</span>
                                        <i className='fas fa-id-card' aria-hidden='true'></i>
                                        Aadhaar Number / आधार संख्या
                                    </label>
                                    <input
                                        id='aadhar'
                                        type='number'
                                        placeholder='Enter your 12-digit Aadhaar number'
                                        required
                                        name='aadhar'
                                        value={val.aadhar}
                                        className='ui_input'
                                        onChange={changeHandle}
                                    />
                                </div>

                                <div className='ui_field'>
                                    <label className='ui_label' htmlFor='dob'>
                                        <span className='ui_required'>*</span>
                                        <i className='fas fa-calendar' aria-hidden='true'></i>
                                        Date of Birth / जन्म तिथि
                                    </label>
                                    <input
                                        id='dob'
                                        type='date'
                                        required
                                        className='ui_input'
                                        name='dob'
                                        value={val.dob}
                                        onChange={changeHandle}
                                    />
                                    {/* The field was labelled "Password - Date of
                                        Birth", which reads as two things. The DOB
                                        IS the password, so say that once. */}
                                    <span className='ui_hint'>Your date of birth is your password.</span>
                                </div>

                                <div className='ui_field'>
                                    <label className='ui_label'>
                                        <span className='ui_required'>*</span>
                                        <i className='fas fa-shield' aria-hidden='true'></i>
                                        Verification
                                    </label>
                                    <div className='ui_captcha'>
                                        <ReCAPTCHA
                                            sitekey={"6LcgtoMjAAAAANRHf5wiCV4Z2Bg6kRZs1wSunjBQ"}
                                            onChange={captchaClick}
                                        />
                                    </div>
                                </div>

                                <button
                                    type='submit'
                                    onClick={onLogin}
                                    className='ui_btn ui_btn_primary ui_btn_block'
                                >
                                    Login
                                </button>

                                <p className='ui_auth_foot'>
                                    Not registered yet? <a href='/register'>Create an account</a>
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
      {/* } */}

    </>
  )
}

const mapStateToProps = (state) => {
  return {
    auth: state.Auth
  }
}

const mapDispatchToProps = { getDataAfterLogin }
export default connect(mapStateToProps, mapDispatchToProps)(Login);
